import AttachmentOpenAction from '../../schema/AttachmentOpenAction';
import AttachmentPreviewMethod from '../../schema/AttachmentPreviewMethod';
import { AttachmentConstants } from 'owa-attachment-model-store';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
function isCloudyAttachment(attachment) {
    return attachment.__type === AttachmentConstants.attachmentTypes.REFERENCE_ATTACHMENT_TYPE;
}
export default function createAttachmentViewStrategy(attachmentPolicyInfo, attachmentClass, attachment) {
    var isCloudy = isCloudyAttachment(attachment);
    var strategy;
    switch (attachmentClass) {
        case 2 /* Image */:
            strategy = createImageAttachmentStrategy();
            break;
        case 3 /* NativeViewableDocument */:
            strategy = createNativeViewableAttachmentStrategy();
            break;
        case 6 /* GoogleDoc */:
            strategy = createGoogleDocAttachmentStrategy();
            break;
        case 4 /* WacViewableDocument */:
            strategy = createWacViewableAttachmentStrategy(attachmentPolicyInfo);
            break;
        case 5 /* Audio */:
            strategy = createAudioAttachmentStrategy();
            break;
        case 7 /* PdfJs */:
            strategy = createPdfJsAttachmentStrategy();
            break;
        case 8 /* ItemAttachment */:
        case 9 /* ItemIdAttachment */:
        case 10 /* Email */:
            strategy = createItemAttachmentStrategy();
            break;
        case 11 /* Text */:
            strategy = createTextAttachmentStrategy();
            break;
        case 12 /* Video */:
            strategy = createVideoAttachmentStrategy();
            break;
        case 1 /* Blocked */:
            strategy = createBlockedAttachmentStrategy();
            break;
        case 13 /* CalendarEvent */:
            strategy = isMailFeatureEnabled('cal-ics-preview')
                ? createICalendarAttachmentStrategy()
                : createClassicGenericAttachmentStrategy();
            break;
        default:
            if (isCloudy) {
                strategy = createReferenceGenericAttachmentStrategy();
            }
            else {
                strategy = createClassicGenericAttachmentStrategy();
            }
            break;
    }
    return strategy;
}
function createClassicGenericAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.Unsupported,
        supportedOpenActions: [AttachmentOpenAction.Download],
    };
}
function createReferenceGenericAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.Unsupported,
        supportedOpenActions: [AttachmentOpenAction.OpenInNewTab],
    };
}
function createBlockedAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.Unsupported,
        supportedOpenActions: [],
    };
}
function createImageAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.Image,
        supportedOpenActions: [AttachmentOpenAction.Preview, AttachmentOpenAction.Download],
    };
}
function createNativeViewableAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.NativeView,
        supportedOpenActions: [AttachmentOpenAction.Preview, AttachmentOpenAction.Download],
    };
}
function createGoogleDocAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.GoogleDoc,
        supportedOpenActions: [AttachmentOpenAction.Preview],
    };
}
function createWacViewableAttachmentStrategy(policyInfo) {
    return {
        allowEdit: policyInfo.wacEdit,
        previewMethod: AttachmentPreviewMethod.Wac,
        supportedOpenActions: [AttachmentOpenAction.Preview, AttachmentOpenAction.Download],
    };
}
function createAudioAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.Audio,
        supportedOpenActions: [AttachmentOpenAction.Preview, AttachmentOpenAction.Download],
    };
}
function createPdfJsAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.PdfJs,
        supportedOpenActions: [AttachmentOpenAction.Preview],
    };
}
function createItemAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.ItemAttachment,
        supportedOpenActions: [AttachmentOpenAction.Preview, AttachmentOpenAction.Download],
    };
}
function createTextAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.Text,
        supportedOpenActions: [AttachmentOpenAction.Preview, AttachmentOpenAction.Download],
    };
}
function createVideoAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.Video,
        supportedOpenActions: [AttachmentOpenAction.Preview, AttachmentOpenAction.Download],
    };
}
function createICalendarAttachmentStrategy() {
    return {
        allowEdit: false,
        previewMethod: AttachmentPreviewMethod.CalendarEvent,
        supportedOpenActions: [AttachmentOpenAction.Preview, AttachmentOpenAction.Download],
    };
}
//# sourceMappingURL=createAttachmentViewStrategy.js.map